<template>
  <div class="textBody1" v-html="replacePlaceholder(text)"></div>
  <div v-if="clientStore.getBkkExtendedDataprivacy && isDataPrivacy">
    <h3 class="text-textHeadline3 mt-4 font-bold">
      {{ $t("dataprivacy.extended.title") }}
    </h3>
    <div class="textBody1" v-html="clientStore.getBkkExtendedDataprivacy"></div>
  </div>
</template>

<script>
import { useClientStore } from "../../../store/v2/client";

export default {
  name: "LegalText",
  props: {
    text: String,
    isDataPrivacy: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    const clientStore = useClientStore();
    return {
      clientStore,
    };
  },
  methods: {
    // https://blg.atlassian.net/browse/BKKC-484
    replacePlaceholder(text) {
      const replacements = {
        bkkDataprivacy: this.clientStore.getBkkDataprivacy ?? "",
        bkkImprint: this.clientStore.getBkkImprint ?? "",
        bkkSupervisory: this.clientStore.getBkkSupervisory ?? "",
        bkkEditorial: this.clientStore.getBkkEditorial ?? "",
      };

      // https://stackoverflow.com/a/61634647
      let replacedText = text.replace(
        /\[\[(\w+)\]\]/g,
        (placeholderWithDelimiters, placeholderWithoutDelimiters) =>
          replacements.hasOwnProperty(placeholderWithoutDelimiters)
            ? replacements[placeholderWithoutDelimiters]
            : placeholderWithDelimiters
      );

      return replacedText;
    },
  },
};
</script>
